import { useNavigate } from "react-router-dom";
import ProductCard from "./ProductCard";
import LoadMoreButton from "../../../shared/ui/LoadMoreButton";

const ProductGrid = ({
  products,
  cardClass = "col-xl-2 col-lg-3 col-sm-4 col-6",
  title = null,
  showLoadmore = true,
  margin_top = "product mt-24",
  // bare: just the grid, for use inside a panel; variant "row": one scrolling row.
  bare = false,
  variant = "grid",
}) => {
  const navigate = useNavigate();
  const gotToAllProducts = () => navigate("/products");
  const grid = (
    <>
        <div className={`row gy-4 g-12 product-grid${variant === "row" ? " product-grid--row" : ""}`}>
          {products.length > 0 ? (
            products.map((product) => (
              <div className={cardClass} key={product.id}>
                <ProductCard product={product} />
              </div>
            ))
          ) : (
            <p className="text-center w-100">No products found</p>
          )}
        </div>
        {showLoadmore && <LoadMoreButton hasMore onClick={gotToAllProducts} />}
        {/* {showLoadmore && (
          <div className="mt-16 d-flex justify-content-center">
            {currentPage < totalPages - 1 ? (
              <button
                onClick={loadMoreProducts}
                className="btn bg-main-600 text-white py-11 px-24 rounded-pill"
              >
                Load More
                
              </button>
            ) : (
              <p className="text-center text-gray-500 mt-4">
                No more products to show.
              </p>
            )}
          </div>
        )} */}
    </>
  );

  if (bare) return grid;

  return (
    <div className="container container-lg">
      <div className={margin_top}>
        {title && (
          <div className="product-section__header">
            <h2 className="product-section__title">{title}</h2>
          </div>
        )}
        {grid}
      </div>
    </div>
  );
};

export default ProductGrid;
